import React from "react";

import { Route, Switch } from "react-router";
import mainRoutes from "./main";

const Routes = () => {
    return (
        <Switch>
            {mainRoutes.map((route, index) => (
                <Route {...route} key={`route_${index}`} />
            ))}
        </Switch>
    );
};

export default Routes;
